export default __webpack_public_path__ + "static/media/miguel-lopes-33.be7b52be.jpg";